import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

export const useEntityByRef = (ref?: string) => {
  const catalogApi = useApi(catalogApiRef);

  return useQuery<Entity, Error>(
    ['entity-by-ref', ref],
    async () => {
      if (!ref) {
        throw new Error('Entity reference is required');
      }
      const entity = await catalogApi.getEntityByRef(ref);

      if (!entity) throw new Error('Entity reference not found');

      return entity;
    },
    {
      enabled: Boolean(ref),
    },
  );
};
